import styled from "styled-components";
import { theme } from "../../helpers/theme";
import { ReactNode, useState } from "react";
import { Box, Modal } from "@mui/material";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { StyledButton } from "../Button/button";

const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: `${theme.colors.gray04_background}`,
    border: `2px solid ${theme.colors.gray02_border}`,
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
    '@media (max-width:260px)': {
        width: "90%",
        transform: "translate(-50%, -50%)",
    },
    '@media (max-width:1024px) and (min-width:540px)': {
        width: "60%",
    },
    '@media (min-width:1024px)': {
        width: "600px",
    },
    width: "70%",
};

interface StyledModalProps {
    modalIsOpen: boolean;
    handleModalClose: () => void,
    children: ReactNode;
};

export const StyledModal = ({
    modalIsOpen,
    handleModalClose,
    children,
}: StyledModalProps) => {


    return (
        <Modal open={modalIsOpen} onClose={handleModalClose}>
            <Box sx={{ ...style }}>
                <ButtonWraper>
                    <StyledButton
                        onClick={handleModalClose}
                        sx={{
                            backgroundColor: `${theme.colors.gray04_background}`,
                            marginBottom: '10px',
                            "&:hover": {
                                backgroundColor: `${theme.colors.gray04_background}`,
                            },
                        }}
                    >
                        <FontAwesomeIcon icon={faTimesCircle as IconProp}
                            size="2x"
                            style={{
                                backgroundColor: `${theme.colors.gray04_background}`,
                                color: `${theme.colors.blue01_active}`,

                            }} />

                    </StyledButton>
                </ButtonWraper>
                {children}
            </Box>
        </Modal>

    )
};

const ButtonWraper = styled.div`
display: flex;
flex-direction: row;
justify-content: flex-end;
`